<template>
  <div class="info-container w-100 h-100" :class="state.infoPanelOpen ? 'open' : '' ">
      <Transition name="fade">
        <div v-if="state.infoPanelOpen" class="bg-black o-10 backdrop absolute top-0 left-0 w-100 h-100 pointer"
        @click.prevent="close"></div>
      </Transition>
      <div class="pricing-info shadow-4 bg-white w-75-l w-100">

        <article class="ph6-l ph4 pv5-l pv4" ref="article">
          <hgroup class="mb4">
            <h2 class="f3 text-extra-bold lh-title">How we calculate query volume fees</h2>
            <h3 class="lh-title text-normal">The price for up to, but not including, one million queries <mark>per
                zone</mark>
              is <mark>$0.10</mark></h3>
          </hgroup>

          <p>
            The DNS query volume fees are calculated at this price every time the registered volume goes beyond any
            given
            million-query mark <em>(starting at 0 queries)</em>
          </p>

          <table class="mb4">
            <thead>
              <tr>
                <th>Query Volume</th>
                <th>Fee</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>1 - 999,999 queries</td>
                <td class="b">$0.10</td>
              </tr>
              <tr>
                <td>1M - 1,999,999 queries</td>
                <td class="b">$0.20</td>
              </tr>
              <tr>
                <td>2M - 2,999,999 queries</td>
                <td class="b">$0.30</td>
              </tr>
            </tbody>
          </table>

          <p>
            <em>And so on...</em>
          </p>

          <h3>We won’t charge fractions of the price:</h3>

          <p>
            Any volume greater or equal to 1M and less than 2M will have a fee of $0.20
            For example, the fee for 1.5M queries is still $0.2.
          </p>

          <p>Let’s explore this using a couple examples.</p>

          <details class="mv4" open>
            <summary class="pointer f3 text-extra-bold mb2">Example 1:</summary>

            <p>
              2,000,000 total queries across 4 zones
              This is a sample list of zones and queries for a billing period in an account:
            </p>
            <ul>
              <li>zone1.com with 500,000 queries</li>
              <li>zone2.com with 100,000 queries</li>
              <li>zone3.com with 1,300,000 queries</li>
              <li>zone4.com with 100,000 queries</li>
            </ul>

            <p>In this scenario, you would see a DNS query volume fee of $0.50 in your invoice:</p>

            <p>zone1.com, zone2.com, and zone4.com contribute each with $0.10, because they don’t surpass the 1M queries
              threshold.</p>

            <p>zone3.com contributes with $0.20, because it has registered between 1M and 2M queries.</p>
          </details>

          <details class="mv4" open>
            <summary class="f3 text-extra-bold mb2 pointer">Example 2:</summary>

            <p>2,000,000 total queries across a single zone.</p>
            <p>What if you have a single zone with a registered query volume of 2M queries?</p>

            <p>
              You would see a DNS query volume fee of $0.30 in your invoice, because zone1.com has registered a volume
              between 2M and 3M queries.
            </p>
          </details>

          <button @click.prevent="close" class="bw0 w-25-l w-100 br-pill pa4 pointer b mt2">Close</button>
          <a target="_blank"
            href="https://support.dnsimple.com/articles/dns-query-limits/#understanding-your-query-volume"
            class="ml4 icon-external-link">More Info</a>
        </article>

        <button @click.prevent="close"
          class="bw0 absolute ma4 top-0 right-0 f2 icon-remove moon-gray bg-white pointer" aria-label="Close window"></button>

      </div>
  </div>
</template>

<script>
export default {
  name: 'PricingInformation',
  inject: ['state'],

  methods: {
    close () {
      this.$refs.article.scrollTop = 0;
      this.state.infoPanelOpen = false;
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~/stylesheets/application/colors";

.pricing-info {
  position: absolute;
  top: 0;
  right: -100%;
  height: 100%;
  opacity: 0;
  transition: right .3s ease-out, opacity .2s ease;
}

.info-container.open .pricing-info {
  right: 0;
  opacity: 1;
}

article {
  height: 100%;
  overflow-y: auto;
}

button {
  transition: all .3s ease;

  &:hover {
    transform: scale(115%);
  }
}

table {
  width: 100%;

  td, th {
    text-align: left;
    padding: .5em;
    border: 1px solid white;
  }

  tbody {
    tr:nth-child(odd) {
      background-color: $gray-200;
    }
  }
}

</style>
